// Shared by the page catalog and edge sitemap; keep this module dependency-free.
export const STRATEGY_PARTNER_SLUGS = ["bitwise"] as const;
